import { render, staticRenderFns } from "./assistance.vue?vue&type=template&id=3809f3ea&scoped=true"
import script from "./assistance.vue?vue&type=script&lang=js"
export * from "./assistance.vue?vue&type=script&lang=js"
import style0 from "./assistance.vue?vue&type=style&index=0&id=3809f3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809f3ea",
  null
  
)

export default component.exports